@if (environment.buildVersion === buildVersion.legal) {
  <app-subscriptions-paywall2025-2-offer
    [subscriptionOffers]="subscriptionOffers"
    [isModal]="true"
    (openPolicy)="openPolicyModal()"
    (openTerms)="openTermsOfUseModal()"
    (onPurchase)="purchase($event)"
    (close)="close()"
  ></app-subscriptions-paywall2025-2-offer>
} @else {
  <app-subscriptions-paywall2025-2-offer
    [subscriptionOffers]="subscriptionOffers"
    [isModal]="true"
    (openPolicy)="openPolicyModal()"
    (openTerms)="openTermsOfUseModal()"
    (onPurchase)="purchase($event)"
    (close)="close()"
  ></app-subscriptions-paywall2025-2-offer>
}
